export const API_URL = 'https://www.googleapis.com/books/v1/volumes';
export const RES_PER_PAGE = 20;
